export default "__VITE_ASSET__ClUiR8BA__"